module.exports = __webpack_public_path__ + "static/media/share-alt.748d27a1.svg";